import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SUPPORTED_LANGUAGES } from "@/i18n";

/**
 * Small language switcher. Persists the choice via i18next's
 * LanguageDetector (localStorage key `pf_lang`). Fits the Navbar +
 * mobile menu; not tied to auth state.
 */
export function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const current =
    SUPPORTED_LANGUAGES.find((l) => l.code === i18n.resolvedLanguage) ||
    SUPPORTED_LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="language-switcher-btn"
          className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white transition"
          aria-label={t("nav.language")}
        >
          <Globe className="w-4 h-4" />
          <span className="font-mono uppercase text-xs">{current.code}</span>
          {!compact && <span className="hidden md:inline">{current.label}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#12141C] border-[#1E212B]">
        {SUPPORTED_LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onSelect={() => i18n.changeLanguage(l.code)}
            className={l.code === current.code ? "text-white" : "text-zinc-400"}
          >
            <span className="font-mono uppercase text-xs mr-2">{l.code}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSwitcher;
